/**
 * @author       yontaek@zumper.com (Yon Taek Chung)
 * @copyright    Copyright (c) 2022, Zumper
 * @description  Constants for Filters module
 */

export const CANCEL_FETCHING_LISTABLES_COUNT = '@@nzr/filters/CANCEL_FETCHING_LISTABLES_COUNT'
export const CLEAR_LISTABLES_COUNT = '@@nzr/filters/CLEAR_LISTABLES_COUNT'
export const DONE_FETCHING_LISTABLES_COUNT = '@@nzr/filters/DONE_FETCHING_LISTABLES_COUNT'
export const ERROR_FETCHING_LISTABLES_COUNT = '@@nzr/filters/ERROR_FETCHING_LISTABLES_COUNT'
export const RECEIVE_LISTABLES_COUNT = '@@nzr/filters/RECEIVE_LISTABLES_COUNT'
export const RESET_FILTERS = '@@nzr/filters/RESET_FILTERS'
export const START_FETCHING_LISTABLES_COUNT = '@@nzr/filters/START_FETCHING_LISTABLES_COUNT'
export const UPDATE_FILTERS = '@@nzr/filters/UPDATE_FILTERS'
export const RESET_NON_ST_FILTERS = '@@nzr/filters/RESET_NON_ST_FILTERS'

// FILTER MODAL
export const SET_FILTER_MODAL_TYPE = '@@nzr/filters/SET_FILTER_MODAL_TYPE'
export const SET_IS_FILTER_MODAL_OPEN = '@@nzr/filters/SET_IS_FILTER_MODAL_OPEN'

// MATCHING COUNT
export const SET_FILTER_MATCHING_COUNT = '@@nzr/filters/SET_FILTER_MATCHING_COUNT'
export const START_FETCHING_MATCHING_COUNT = '@@nzr/filters/START_FETCHING_MATCHING_COUNT'
export const DONE_FETCHING_MATCHING_COUNT = '@@nzr/filters/DONE_FETCHING_MATCHING_COUNT'

export const SET_SHORT_TERM_CALENDAR_OPEN = '@@nzr/filters/SET_SHORT_TERM_CALENDAR'

export const SET_FILTERS_CHANGED = '@@nzr/filters/SET_FILTERS_CHANGED'

// PROPERTY TYPE COUNTS
export const SET_PROPERTY_TYPE_COUNTS = '@@nzr/filters/SET_PROPERTY_TYPE_COUNTS'
export const START_FETCHING_PROPERTY_TYPE_COUNTS =
  '@@nzr/filters/START_FETCHING_PROPERTY_TYPE_COUNTS'
export const DONE_FETCHING_PROPERTY_TYPE_COUNTS = '@@nzr/filters/DONE_FETCHING_PROPERTY_TYPE_COUNTS'
